export default "__VITE_ASSET__Cy7f_4Fm__"